<sdps-modal id='beta-upload-LOA-request-modal' [sdpsTitle]="title || addLinkConstant.takeActionMenuMsg.uploadLOATxt" [size]="'flex--small'" (close)="closeModal()">
  <div slot="modal-body">
    <sdps-notification type="error" class="sdps-m-top_none" *ngIf="(showError || showUploadError)">
      <div class="sdps-notification__text">
        <p *ngIf="showError && !showUploadError" [innerHTML]="errorMessage"></p>
        <p *ngIf="uploadErrorFileMsg" [innerHTML]="uploadErrorFileMsg"></p>
      </div>
    </sdps-notification>
    <p class="adl-modal__heading"><strong>Eligible Request(s) selected for Uploading LOA:</strong></p>

    <div *ngIf="requestIds && requestIds.length > 0" class="adl-modal__request-list show-scrollable-list">
      <div *ngFor="let requestId of requestIds" class="adl-modal__request-id">#{{requestId}}</div>
    </div>

    <div class="adl-modal__upload-section">
      <div class="spinner file-section sdps-m-top_x-large" ems-drag-drop #content id="uploadLOA">
        <div class="display-content sdps-p-bottom_large" [innerHTML]="sharedConstant.bulkUpload.uploadLOAText"></div>
        <div class="widget" [ngClass]=" 'cursor'">
          <app-sch-file-upload-widget [channelContract]="channelDetails" [channelFileThresholdCount]=1
            [overrideWidgetErrors]="overrideWidgetErrors" [widgetId]="'widget'" [tooltipConfig]="tooltipConfig"
            [reHydrate]="reHydrateData" [errorDisplay]="errorDisplay"
            [needFileStatus]="false"></app-sch-file-upload-widget>
        </div>
      </div>
    </div>
  </div>

  <div slot="modal-footer">
    <button class="buttons" type="button" (click)="closeModal()">
      Close
    </button>
  </div>
</sdps-modal>